import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AppConfig, APP_CONFIG_TOKEN } from "libs/config/app.lib.config";
import { CmsBlockKey, CmsBlockModel, CmsBlockModelPublicResponse, CmsBlockPublicKey } from "../models";

@Injectable({
	providedIn: "root",
})
export class CmsService {
	private http = inject(HttpClient);
	private config = inject<AppConfig>(APP_CONFIG_TOKEN);

	baseUrl: string = "";

	constructor() {
		this.baseUrl = this.config.apiUrl;
	}

	getCmsBlocks(): Observable<CmsBlockModel[]> {
		return this.http.get<CmsBlockModel[]>(`${this.baseUrl}/cms`);
	}

	getCmsBlock<T = any>(key: CmsBlockKey): Observable<CmsBlockModel<T>> {
		return this.http.get<CmsBlockModel<T>>(`${this.baseUrl}/cms/${key}`);
	}

	getPublicCmsBlock<T = any>(key: CmsBlockPublicKey): Observable<CmsBlockModelPublicResponse<T>> {
		return this.http.get<CmsBlockModelPublicResponse<T>>(`${this.baseUrl}/cms/public/${key}`);
	}

	getCmsBlockAsAdmin<T = any>(key: string): Observable<CmsBlockModel<T>> {
		return this.http.get<CmsBlockModel<T>>(`${this.baseUrl}/cms/admin/${key}`);
	}

	createCmsBlock(cmsBlock: CmsBlockModel) {
		const body = { ...cmsBlock, content: JSON.parse(cmsBlock.content) };
		return this.http.post(`${this.baseUrl}/cms`, body);
	}

	updateCmsBlock<T = any>(key: string, cmsBlock: Partial<CmsBlockModel<T>>): Observable<CmsBlockModel<T>> {
		return this.http.patch<CmsBlockModel<T>>(`${this.baseUrl}/cms/${key}`, cmsBlock);
	}

	deleteCmsBlock(key: string) {
		return this.http.delete(`${this.baseUrl}/cms/${key}`);
	}
}
